import * as React from 'react'
import {getFieldValue} from '../../core/helpers'
import {
  IControlQueries,
  IDataQuery,
  IFeatureLayerInfos,
  IGeometryQuery,
  IRawQueries,
  QueryTarget
} from '../../core/interfaces/reducers'
import {Feature} from '../../core/models'
import {IAppUser} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import ReactTable, {Column, Filter, RowInfo, SortingRule} from 'react-table'
import {IFeatureLayerInfo, ITableProps} from '../../core/interfaces/models'
import Pagination from '../../core/components/Tables/Pagination'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {DataFilters} from '../../core/components/DataFilters/DataFilters'
import {ServiceHub} from '../../core/ServiceHub'
interface Props {
  onChangeStatus: (plan: Feature, status: number) => void
  onSelectedHistory: (feature: Feature) => void
  infos: IFeatureLayerInfos
  onCreateNew: () => void
  user?: IAppUser
  refreshPlansHandle: (refreshPlans: () => void) => void
}

export enum PlanHistoryStatus {
  Added = 1,
  Rejected = 2,
  Fixed = 3,
  Approved = 4
}
interface State {
  loading: boolean
  dataQuery?: IDataQuery
  showFilters: boolean
  newSorted: SortingRule[]
  pageSize: number
  resultCount: number
  page: number
  archPlans: Feature[]
}

export class ArchRegister extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showFilters: false,
      newSorted: [],
      loading: true,
      pageSize: 10,
      resultCount: 0,
      page: 0,
      archPlans: []
    }
  }
  initPlanLoaded = false

  _loadPlans = (props: Props) => {
    const info = props.infos[appConfig.archImport.plan.url]
    const wherre = {where: '1=1', start: 0, num: this.state.pageSize}
    this.setState({...this.state, loading: true}, () => {
      ServiceHub.gisCrudService.executeForCount(info, wherre).then(c => {
        ServiceHub.gisCrudService.execute(info, wherre).then(p => {
          this.setState({...this.state, archPlans: p, loading: false, resultCount: c, dataQuery: undefined, page: 0})
        })
      })
    })
  }
  loadPlans(props: Props) {
    if (this.initPlanLoaded == false && props.infos && Object.keys(props.infos).length > 0) {
      this.initPlanLoaded = true
      this.props.refreshPlansHandle(() => this.applyQuery(false))
      this._loadPlans(props)
    }
  }
  componentDidMount() {
    this.loadPlans(this.props)
  }
  getButtons(plan: Feature) {
    const buttons: JSX.Element[] = []
    if (this.props.user && plan.get('ArchPlanHistoryStatusId') != PlanHistoryStatus.Approved) {
      if (this.props.user.isArchControl && plan.get('ArchPlanHistoryStatusId') != PlanHistoryStatus.Rejected) {
        buttons.push(
          <span
            key={1}
            className="arch-span-btn red"
            title="Върни със забележи"
            onClick={() => this.props.onChangeStatus(plan, PlanHistoryStatus.Rejected)}
          >
            <i className="fas fa-exclamation-circle" />
          </span>
        )
        buttons.push(
          <span
            key={2}
            className="arch-span-btn green"
            title="Одобри"
            onClick={() => this.props.onChangeStatus(plan, PlanHistoryStatus.Approved)}
          >
            <i className="fas fa-check-circle" />
          </span>
        )
      } else if (
        this.props.user.isArchImportUser &&
        plan.get('ArchPlanHistoryStatusId') == PlanHistoryStatus.Rejected
      ) {
        buttons.push(
          <span
            key={3}
            className="arch-span-btn green"
            title="Прати нов вариант"
            onClick={() => this.props.onChangeStatus(plan, PlanHistoryStatus.Fixed)}
          >
            <i className="fas fa-pen-square" />
          </span>
        )
      }
    }
    buttons.push(
      <span key={4} className=" arch-span-btn" title="Виж повече" onClick={() => this.props.onSelectedHistory(plan)}>
        <i className="fas fa-info-circle" />
      </span>
    )
    return buttons
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.infos !== this.props.infos) {
      this.loadPlans(this.props)
    }
  }

  setFilters = (
    key: string,
    controlQueries?: IControlQueries,
    rawQueries?: IRawQueries,
    geometryQuery?: IGeometryQuery,
    updateClients: boolean = true
  ) => {
    let dataQuery: IDataQuery = {
      controledQueries: {},
      rawQueries: {}
    }
    if (this.state.dataQuery) {
      dataQuery = {...this.state.dataQuery!}
    }

    if (controlQueries) {
      dataQuery.controledQueries = {...dataQuery.controledQueries, ...controlQueries}
    } else {
      dataQuery.controledQueries = {}
    }
    if (rawQueries) {
      dataQuery.rawQueries = {...dataQuery.rawQueries, ...rawQueries}
    } else {
      dataQuery.rawQueries = {}
    }
    dataQuery.geometryQuery = geometryQuery
    this.computeWhere(dataQuery)
    this.setState({...this.state, dataQuery: dataQuery, showFilters: false}, () => {
      this.applyQuery(false)
    })
  }
  protected computeWhere(dataQuery: IDataQuery) {
    const dataWheres: string[] = []
    const mapDataWheres: string[] = []
    for (const key in dataQuery.controledQueries) {
      if (dataQuery.controledQueries[key].where) {
        if (dataQuery.controledQueries[key].queryTarget & QueryTarget.Data) {
          dataWheres.push(dataQuery.controledQueries[key].where)
        }
        if (dataQuery.controledQueries[key].queryTarget & QueryTarget.Map) {
          mapDataWheres.push(dataQuery.controledQueries[key].where)
        }
      }
    }
    for (const key in dataQuery.rawQueries) {
      if (dataQuery.rawQueries[key].where) {
        if (dataQuery.rawQueries[key].queryTarget & QueryTarget.Data) {
          dataWheres.push(dataQuery.rawQueries[key].where)
        }
        if (dataQuery.rawQueries[key].queryTarget & QueryTarget.Map) {
          mapDataWheres.push(dataQuery.rawQueries[key].where)
        }
      }
    }
    dataQuery.dataWhere = dataWheres.join(' AND ')
    dataQuery.mapDataWhere = mapDataWheres.join(' AND ')
  }

  isFiltered = () => {
    return this.state.dataQuery && !!this.state.dataQuery.dataWhere
  }

  applyQuery = (preservePage: boolean) => {
    if (!this.props.user) {
      return
    }
    const info = this.props.infos[appConfig.archImport.plan.url]
    const wherre = {
      where: this.state.dataQuery ? this.state.dataQuery.dataWhere || '1=1' : '1=1',
      orderByFields:
        this.state.newSorted.length > 0
          ? [`${this.state.newSorted[0].id} ${this.state.newSorted[0].desc ? 'DESC' : 'ASC'}`]
          : undefined
    }
    const wherePaged = {
      ...wherre,
      num: this.state.pageSize,
      start: preservePage ? this.state.pageSize * this.state.page : 0
    }
    this.setState({...this.state, loading: true, page: preservePage ? this.state.page : 0}, () => {
      ServiceHub.gisCrudService.executeForCount(info, wherre).then(c => {
        ServiceHub.gisCrudService.execute(info, wherePaged).then(p => {
          this.setState({...this.state, archPlans: p, loading: false, resultCount: c})
        })
      })
    })
    // this.setState({ ...this.state, loading: true }, () => {
    //     ServiceHub.gisCrudService.execute(
    //         this.props.infos[appConfig.archImport.plan.url],
    //         )
    //         .then(p => {
    //             this.setState({ ...this.state, archPlans: p, loading: false })
    //         })
    // })
  }

  protected getFeatureTableColumns(featureLayerInfo: IFeatureLayerInfo): Array<Column> {
    const columns: Array<Column> = [
      {
        expander: true,
        show: false
      } as any
    ]
    let fieldNames = featureLayerInfo.sourceDescription.tableFields
    if (!fieldNames) {
      fieldNames = []
      for (const name in featureLayerInfo.fields) {
        if (name != 'geometry') fieldNames.push(name)
      }
    }
    fieldNames!.forEach(fieldName => {
      if (featureLayerInfo.fields[fieldName]) {
        if (featureLayerInfo.fields[fieldName].codedValues) {
          columns.push({
            id: featureLayerInfo.fields[fieldName].fieldName,
            Header: featureLayerInfo.fields[fieldName].label,
            accessor: (d: Feature) =>
              getFieldValue(
                featureLayerInfo.fields[featureLayerInfo.fields[fieldName].fieldName],
                d.getProperties()[featureLayerInfo.fields[fieldName].fieldName]
              ),
            Cell: cellInfo => (
              <div>
                {getFieldValue(
                  featureLayerInfo.fields[featureLayerInfo.fields[fieldName].fieldName],
                  cellInfo.original.getProperties()[featureLayerInfo.fields[fieldName].fieldName]
                )}
              </div>
            )
          })
        } else {
          columns.push({
            id: featureLayerInfo.fields[fieldName].fieldName,
            Header: featureLayerInfo.fields[fieldName].label,
            accessor: (d: Feature) =>
              getFieldValue(
                featureLayerInfo.fields[featureLayerInfo.fields[fieldName].fieldName],
                d.getProperties()[featureLayerInfo.fields[fieldName].fieldName]
              )
          })
        }
      }
    })
    columns.push({
      id: 'actions',
      Cell: cellInfo => this.getButtons(cellInfo.original),
      width: 100
    })
    return columns
  }
  protected getDefaultProps1(): ITableProps {
    return {
      manual: true,
      pageSize: this.state.pageSize,
      collapseOnSortingChange: true,
      collapseOnPageChange: true,
      collapseOnDataChange: true,
      noDataText: 'Няма данни',
      pageText: '',
      defaultFilterMethod: (filter: Filter, row: any, column: any) => {
        if (row[column.id] && filter.value) {
          return (row[column.id] as number).toString().toUpperCase().indexOf(filter.value.toUpperCase()) == 0
        }
        return filter.value!
      },
      ofText: 'от',
      nextText: '>',
      previousText: '<',
      onExpandedChange: (column: any, event: any, isTouch: boolean) => {},
      className: '-highlight',
      getTdProps: (finalState: any, rowInfo?: RowInfo, column?: any, instance?: any) => {
        return {
          style: {
            justifyContent: column && column.id != 'actions' ? '' : 'flex-end ',
            alignItems: 'center',
            display: 'flex'
          }
        }
      },
      getTrGroupProps: (finalState: any, rowInfo?: RowInfo, column?: undefined, instance?: any) => {
        return {
          style: {
            border: 'white'
          }
        }
      },
      style: {height: '100%'}
    } as ITableProps
  }

  getFilters() {
    const info = this.props.infos[appConfig.archImport.plan.url]
    const query = this.state.dataQuery

    if (!info) {
      return null
    }
    return (
      <div
        className="arch-filterrs"
        style={{
          maxHeight: this.state.showFilters ? '1000px' : '0',
          paddingBottom: this.state.showFilters ? '5px' : '0'
        }}
      >
        <DataFilters
          expandable={false}
          layerInfo={info}
          defaultExpanded={true}
          defaultControlQueries={query ? query.controledQueries : {}}
          setQueries={this.setFilters}
        ></DataFilters>
      </div>
    )
  }

  getRows() {
    const info = this.props.infos[appConfig.archImport.plan.url]
    if (!info) {
      return null
    }
    const defProps = this.getDefaultProps1()
    defProps.id = appConfig.archImport.plan.url
    defProps.idColumnName = info.sourceDescription.idField
    defProps.columns = this.getFeatureTableColumns(info)
    defProps.data = this.state.archPlans
    defProps.recordsCount = this.state.resultCount
    defProps.pages =
      (this.state.resultCount - (this.state.resultCount % this.state.pageSize!)) / this.state.pageSize! +
      (this.state.resultCount % this.state.pageSize! > 0 ? 1 : 0)
    defProps.page = this.state.page
    defProps.canNext = defProps.pages > this.state.page + 1
    defProps.canPrevious = this.state.page > 0 && defProps.pages > 1
    defProps.onSortedChange = (newSorted: SortingRule[], column: any, additive: boolean) => {
      this.setState({...this.state, newSorted: [...newSorted]}, () => {
        this.applyQuery(true)
      })
    }
    defProps.sorted = this.state.newSorted
    return (
      <div style={{position: 'relative', height: 'calc(100% - 225px)'}}>
        {this.getFilters()}
        <ReactTable
          {...defProps}
          PaginationComponent={() => (
            <Pagination
              tools={[]}
              {...defProps}
              onPageChange={page => {
                this.setState({...this.state, page: page}, () => {
                  this.applyQuery(true)
                })
              }}
            ></Pagination>
          )}
        />
      </div>
    )
  }

  getPresentation() {
    return (
      <div className="arch-hello">
        <div>РЕГИСТЪР НА ИНВЕСТИЦИОННИ И ТЕРИТОРИАЛНИ ПРОЕКТИ</div>
        {this.props.user && this.props.user.isArchImportUser ? (
          <div>Тук може да прегледате подадените от Вас инв. и тер. проекти, както и да подадете нови такива.</div>
        ) : null}

        {this.props.user && this.props.user.isArchImportUser ? (
          <button type="button" className="button" onClick={this.props.onCreateNew}>
            ИЗПРАТИ НОВ ПРОЕКТ
          </button>
        ) : null}
        {this.hasNoRecords() ? null : (
          <button
            type="button"
            className="button"
            onClick={() => this.setState({...this.state, showFilters: !this.state.showFilters})}
          >
            ФИЛТРИ
          </button>
        )}
      </div>
    )
  }

  hasNoRecords() {
    return this.state.archPlans.length == 0 && !this.isFiltered()
  }

  getContent() {
    return (
      <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
        {this.getPresentation()}
        {this.hasNoRecords() ? null : this.state.loading ? null : this.getRows()}
        {this.state.archPlans.length == 0 && !this.isFiltered() ? (
          <div className="arch-no-plans">{this.state.loading ? 'Зареждане...' : 'Няма подадени проекти'}</div>
        ) : null}
      </div>
    )
  }

  render() {
    return (
      <div className="arch-register arch-panel">
        <OverlayLoader show={this.state.loading}></OverlayLoader>
        {this.getContent()}
      </div>
    )
  }
}
